import Switch from 'components/Luxkit/Switch/Switch'
import BodyText from 'components/Luxkit/Typography/BodyText'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import React, { useCallback } from 'react'
import useLuxLoyaltyOfferPageTargetRoomUpgrade from 'components/OfferPage/hooks/useLuxLoyaltyOfferPageTargetRoomUpgrade'

interface Props {
  package: App.Package;
}

function OfferPageLuxLoyaltyRoomUpgradeCallOutBannerSwitch({
  package: pkg,
}: Props) {
  const {
    selectedTargetUpgradePackage,
    toggleTargetRoomUpgrade,
  } = useLuxLoyaltyOfferPageTargetRoomUpgrade(pkg)

  const handleToggleTargetRoomUpgrade = useCallback(() => {
    toggleTargetRoomUpgrade(!selectedTargetUpgradePackage)
  }, [selectedTargetUpgradePackage, toggleTargetRoomUpgrade])

  return <Group direction="horizontal" verticalAlign="center" gap={8}>
    <CSSBreakpoint min="tablet">
      {!selectedTargetUpgradePackage && <BodyText variant="medium" wrap="no-wrap">Upgrade room</BodyText>}
      {!!selectedTargetUpgradePackage && <BodyText variant="medium" wrap="no-wrap">Room upgraded</BodyText>}
    </CSSBreakpoint>
    <Switch checked={!!selectedTargetUpgradePackage} onChange={handleToggleTargetRoomUpgrade} />
  </Group>
}

export default OfferPageLuxLoyaltyRoomUpgradeCallOutBannerSwitch
